<div class="app-isf-ocr-quick-fix-csl-details">
  <div class="app-isf-ocr-quick-fix-csl-details__header">
    <div class="app-isf-ocr-quick-fix-csl-details__header__left">
      <p class="app-isf-ocr-quick-fix-csl-details__header__title">
        {{ "ENTITY.STAFFING_LOCATION" | translate | uppercase }}
      </p>

      <app-hint-tooltip-icon [hint]="'INFO.LG.SUB_TITLE' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <div class="app-isf-ocr-quick-fix-csl-details__row">
    <p class="app-isf-ocr-quick-fix-csl-details__text m-0">
      {{ "INFO.LG.SUB_TITLE" | translate }}
    </p>
    <p class="app-isf-ocr-quick-fix-csl-details__hint-text">{{ "LABELS.USE_PREV_INFO" | translate }}</p>
  </div>

  <div class="app-isf-ocr-quick-fix-csl-details__row">
    <app-entity-unify-card
      *ngIf="!!seller && isEditMode"
      [entity]="seller"
      [formGroup]="formGroup"
      [code]="enumEntityModelCode.STAFFING_LOCATION"
      [selectedValueControl]="formGroup.get('id')"
      [labelOverride]="'INFO.LG.USE_SE_DESKTOP'"
      [isDesktop]="isDesktop"
    ></app-entity-unify-card>
  </div>

  <div class="app-isf-ocr-quick-fix-csl-details__row">
    <app-section-form-block-layout
      *ngIf="!!stuffingLocationFields"
      [formGroup]="formGroup"
      [editBlockDescription]="!!seller && isEditMode ? 'LABELS.OR_ADD_DETAILS' : ''"
      [fields]="stuffingLocationFields"
      [displayFields]="stuffingLocationDisplayFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(stuffingLocationFields, formGroup)"
      [isHideBorder]="true"
      editBlockClass="normal-gap"
      (edit)="onBlockEdit($event)"
    >
      <address-update
        edit-block-body
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.STAFFING_LOCATION"
        [errors]="formErrors"
        [isShowState]="true"
        [isShowCountry]="true"
        [isDesktop]="true"
        [defaultCountry]="null"
        [isFilterRestrictedCountries]="false"
      ></address-update>
    </app-section-form-block-layout>
  </div>

  <ng-container *ngIf="isEditMode">
    <hr class="app-isf-ocr-quick-fix-csl-details__hr" />

    <div class="app-isf-ocr-quick-fix-csl-details__clear-form-btn" (click)="onClearForm()">
      <i class="fa fa-trash btn-remove-icon"></i>
      {{ "FORM_LABEL.CLEAN_FORM" | translate }}
    </div>
  </ng-container>

  <missing-fields [code]="'LABELS.ISF'" (decline)="onSubmit(false)"></missing-fields>
</div>
